import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview"]

  preview(event) {
    const files = event.target.files
    this.previewTarget.innerHTML = ""

    Array.from(files).forEach((file, index) => {
      const reader = new FileReader()
      reader.onload = (e) => {
        const div = document.createElement("div")
        div.className = "relative inline-block"
        div.dataset.index = index
        div.innerHTML = `
          <img src="${e.target.result}" class="w-32 h-32 object-cover rounded">
          <button type="button"
                  class="btn-outlined btn-sm mt-1 w-full"
                  data-action="click->photo-upload#remove"
                  data-index="${index}">
            Remove
          </button>
        `
        this.previewTarget.appendChild(div)
      }
      reader.readAsDataURL(file)
    })
  }

  remove(event) {
    event.preventDefault()
    const previewDiv = event.target.closest('[data-index]')
    if (previewDiv) {
      previewDiv.remove()
    }
  }
}
